/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { kRV_GetATPLeadTimeWithDateAsync } from '../actions/customProxy/ATP/DataActionExtension.g';
import { IKRV_ATPLeadTimePropertiesDate, IKRV_ATPLeadTimeRequestBody } from '../actions/customProxy/ATP/DataServiceEntities.g';

/**
 * TrafficLightsAtp Input Action
 */
export class TrafficLightsAtpInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    public itemId: string;
    public requestDate: string;
    constructor(itemId: string, requestDate: string) {
        this.itemId = itemId;
        this.requestDate = requestDate;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `TrafficLightsAtp`;
    public getCacheObjectType = () => 'TrafficLightsAtp';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface ITrafficLightsAtpData {
    // text: string;
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
// const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
//     return new TrafficLightsAtpInput();
// };

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function trafficLightsAtpaction(
    input: TrafficLightsAtpInput,
    ctx: Msdyn365.IActionContext
): Promise<IKRV_ATPLeadTimePropertiesDate> {
    const requestBody: IKRV_ATPLeadTimeRequestBody = {
        itemId: input.itemId,
        requestedDate: input.requestDate
    };
    const response = await kRV_GetATPLeadTimeWithDateAsync({ callerContext: ctx }, requestBody.itemId, requestBody.requestedDate);
    return response;
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // TODO: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<ITrafficLightsAtpData[]>('/get/example/id/1', 'get');
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IKRV_ATPLeadTimePropertiesDate>>trafficLightsAtpaction,
    // TODO: Give your data action a unique id
    id: 'TrafficLightsAtp'
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
